import { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
import { Button, Dialog, Empty, SpinLoading } from "antd-mobile";
import useNavigation from "../../hooks/useNavigation";
import PageWrap from "../components/PageWrap";
import PageHeader from "../components/PageHeader";
import { useStores } from "../../models";
import { ToastError, ToastSuccess } from "../../components/Toast";
import {
  PayPasswordModal,
  payTypeImage,
  payTypeLabel,
} from "../../components/Wallet";

const Body = styled.div`
  height: calc(100% - 50px);
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

const ScrollArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow: auto;
  background: #f7f8ff;
`;

const Tip = styled.div`
  flex-shrink: 0;
  background: rgb(207, 237, 255);
  color: #1c9cea;
  padding: 10px 12px;
  font-size: 13px;
  text-align: center;
`;

const Card = styled.div`
  background: #fff;
  margin: 8px 12px;
  padding: 12px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Footer = styled.div`
  flex-shrink: 0;
  height: 72px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  background: #fff;
  border-top: 1px solid #eee;
`;

const PayAccountManage = () => {
  const { navigate } = useNavigation();
  const { walletStore, apiStore, authStore } = useStores();
  const [loading, setLoading] = useState(true);
  const [pwdVisible, setPwdVisible] = useState(false);
  const { realName, pay_pwd, paymentList } = walletStore;

  const load = async () => {
    try {
      setLoading(true);
      await walletStore.loadPaymentList();
    } catch (e: any) {
      ToastError(e.message || "加载失败");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAdd = () => {
    if (!realName) {
      Dialog.confirm({
        title: "提示",
        content: "添加的支付方式需与身份证实名一致,请先完成身份认证",
        confirmText: "确定",
        cancelText: "取消",
        onConfirm: () => navigate("Verified"),
      });
      return;
    }
    if (pay_pwd) setPwdVisible(true);
    else {
      Dialog.confirm({
        title: "提示",
        content: "请先绑定支付密码",
        confirmText: "前往绑定",
        cancelText: "之后再说",
        onConfirm: () => navigate("SettingPayNumber"),
      });
    }
  };

  return (
    <PageWrap>
      <PageHeader title="收付款管理" />
      <Body>
        <Tip>喜鹊币钱包仅支持绑定账户实名者本人银行卡</Tip>
        <ScrollArea>
          {loading ? (
            <div style={{ display: "flex", justifyContent: "center", padding: 40 }}>
              <SpinLoading />
            </div>
          ) : !paymentList?.length ? (
            <Empty description="暂无收款方式" style={{ padding: 40 }} />
          ) : (
            paymentList.map((item: any, idx: number) => (
              <Card key={`${item.id}-${idx}`}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={payTypeImage(item.pay_type)}
                    alt=""
                    width={28}
                    height={28}
                    style={{ marginRight: 10 }}
                  />
                  <div>
                    <div>
                      {item.real_name || "-"} / {payTypeLabel(item.pay_type)}
                    </div>
                    <div style={{ color: "#666", fontSize: 13 }}>
                      {item.pay_account}
                      {item.bank_name ? ` · ${item.bank_name}` : ""}
                    </div>
                  </div>
                </div>
                <Button
                  size="mini"
                  color="danger"
                  onClick={() => {
                    Dialog.confirm({
                      content: "确定删除该收款方式？",
                      onConfirm: async () => {
                        try {
                          await apiStore.deletePayment({
                            token: authStore.getToken,
                            id: String(item.id),
                          });
                          ToastSuccess("已删除");
                          load();
                        } catch (err: any) {
                          ToastError(err.message);
                        }
                      },
                    });
                  }}
                >
                  删除
                </Button>
              </Card>
            ))
          )}
        </ScrollArea>
        <Footer>
          <Button color="primary" block onClick={handleAdd}>
            添加收付款信息
          </Button>
        </Footer>
      </Body>
      <PayPasswordModal
        visible={pwdVisible}
        setVisible={setPwdVisible}
        callBack={(ok) => ok && navigate("SettingPayMode")}
      />
    </PageWrap>
  );
};

export default observer(PayAccountManage);
